/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var NaturePlantTreeAIcon16Solid = forwardRef('NaturePlantTreeAIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8.51 1.463a3.5 3.5 0 0 1 5.19 3.638A4.5 4.5 0 0 1 9 12.647V15a1 1 0 1 1-2.001 0v-2.353a4.5 4.5 0 0 1-4.66-7.58 3.75 3.75 0 0 1 6.17-3.605ZM7.25 12h1.5V8.753l2.864-1.322a.75.75 0 1 0-.628-1.362L8.75 7.101V4.75a.75.75 0 0 0-1.5 0v3.582L5.054 7.32a.75.75 0 0 0-.628 1.362L7.25 9.984V12Z" })));
});
